import { useState } from 'react';

import { getFromSessionStorage, setSessionStorage } from 'lib/sessionStorage';
import { isDev } from 'lib/utils';

const useSessionStorageState = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const localStorageValue = getFromSessionStorage(key);

      return localStorageValue ? JSON.parse(localStorageValue) : initialValue;
    } catch (error) {
      if (isDev()) {
        // eslint-disable-next-line no-console
        console.error(error);
      }

      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;

      setStoredValue(valueToStore);

      setSessionStorage(key, JSON.stringify(valueToStore));
    } catch (error) {
      if (isDev()) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };

  return [storedValue, setValue];
};

export default useSessionStorageState;
